import { render, staticRenderFns } from "./AlertExpireBar.vue?vue&type=template&id=592450fa&scoped=true&"
import script from "./AlertExpireBar.vue?vue&type=script&lang=js&"
export * from "./AlertExpireBar.vue?vue&type=script&lang=js&"
import style0 from "./AlertExpireBar.vue?vue&type=style&index=0&id=592450fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592450fa",
  null
  
)

export default component.exports